import React, { useMemo } from "react";

import { ColumnType } from "antd/es/table";
import { defineMessages, IntlShape } from "react-intl";

import { GuideType } from "@mapmycustomers/shared/enum/guides";
import { Guide } from "@mapmycustomers/shared/types/entity";

import GuideTypeTag from "@app/scene/onboarding/components/GuideTypeTag";

const messages = defineMessages({
  description: {
    id: "onboarding.users.assignModal.table.column.description",
    defaultMessage: "Description",
    description: "Name of a Description column in Assign Guides modal on Users Guides page",
  },
  guide: {
    id: "onboarding.users.assignModal.table.column.guide",
    defaultMessage: "Guide",
    description: "Name of a Guide column in Assign Guides modal on Users Guides page",
  },
  type: {
    id: "onboarding.users.assignModal.table.column.type",
    defaultMessage: "Type",
    description: "Name of a Type column in Assign Guides modal on Users Guides page",
  },
});

const useColumns = (intl: IntlShape) =>
  useMemo<ColumnType<Guide>[]>(() => {
    return [
      {
        dataIndex: "displayName",
        sorter: (a, b) => a.displayName.localeCompare(b.displayName),
        title: intl.formatMessage(messages.guide),
        width: "200px",
      },
      {
        dataIndex: "type",
        render: (type: GuideType) => <GuideTypeTag type={type} />,
        title: intl.formatMessage(messages.type),
        width: "50px",
      },
      {
        dataIndex: "description",
        title: intl.formatMessage(messages.description),
        width: "400px",
      },
    ];
  }, [intl]);

export default useColumns;
